import { InvoiceStatus } from '@/Components/Invoicing/InvoiceStatus';
import { Label } from '@/Models/GenericWorklist/Label';
import { type Language } from '@/Models/GenericWorklist/Language';
import type PatientOriginFilter from '@/Models/GenericWorklist/PatientOriginFilter';
import type PatientStatusFilter from '@/Models/GenericWorklist/PatientsStatusFilter';
import type ReportStatusFilter from '@/Models/GenericWorklist/ReportStatusFilter';
import { Urgency } from '@/Models/GenericWorklist/Urgency';
import Modality from '@/Models/Modality';
import { Group } from '../Shared/Group';
import CustomWorklistDTO, { mapDTOToCustomWorklist, type CustomWorklist } from './CustomWorklist';
import { type Room, type SiteInfo } from './Room';
import { StatusModel } from '@/Models/GenericWorklist/StatusModel';

export interface WorklistInitialDataDTO {
    Groups: Group[];
    Languages: Language[];
    LabelsToInclude: Label[];
    LabelsToExclude: Label[];
    PatientOrigins: PatientOriginFilter[];
    PatientStatuses: PatientStatusFilter[];
    OrderStatuses: StatusModel[];
    Urgencies: Urgency[];
    Rooms: Room[];
    Sites: SiteInfo[];
    Statuses: StatusModel[];
    CustomWorklists: CustomWorklistDTO[];
    Modalities: Modality[];
    InvoiceStatuses: InvoiceStatus[];
    ReportStatuses: ReportStatusFilter[];
}

export interface WorklistInitialData {
    Groups: Group[];
    Languages: Language[];
    LabelsToInclude: Label[];
    LabelsToExclude: Label[];
    PatientOrigins: PatientOriginFilter[];
    PatientStatuses: PatientStatusFilter[];
    OrderStatuses: StatusModel[];
    Urgencies: Urgency[];
    Rooms: Room[];
    Sites: SiteInfo[];
    Statuses: StatusModel[];
    CustomWorklists: CustomWorklist[];
    Modalities: Modality[];
    InvoiceStatuses: InvoiceStatus[];
    ReportStatuses: ReportStatusFilter[];
}

export const mapDTOToWorklistInitialData = (dto: WorklistInitialDataDTO): WorklistInitialData => {
    const { Groups, Rooms, Sites, Statuses, PatientStatuses, PatientOrigins, Languages, LabelsToInclude, LabelsToExclude, Urgencies, OrderStatuses, CustomWorklists, Modalities, InvoiceStatuses, ReportStatuses } = dto;
    return {
        Groups,
        Languages,
        LabelsToInclude,
        LabelsToExclude,
        PatientOrigins,
        PatientStatuses,
        Rooms,
        Sites,
        Statuses,
        Urgencies,
        OrderStatuses,
        Modalities,
        InvoiceStatuses,
        ReportStatuses,
        CustomWorklists: CustomWorklists.map((customWorklistDTO) => mapDTOToCustomWorklist(customWorklistDTO)),
    };
};
